import {ComponentConfigurationClass} from "@zoovu/runner-browser-api";
import {ConfigurationValues, ValuesConfigurationConstructor} from "./values";

/**
 * @additionalProperties false
 */
@ValuesConfigurationConstructor(ConfigurationValues.TopProduct)
@ComponentConfigurationClass("topProductSettings")
export class TopProductConfiguration {
    /**
     * @title Show top products on the results pages
     */
    public showTopProductsOnResultsPages?: boolean;

    /**
     * @minimum 0
     * @maximum 10
     */
    public numberOfTopProductsPerResultsPage?: number;

    /**
     *
     */
    public showTopProductsOnQuestionnairePages?: boolean;

    /**
     * @minimum 0
     * @maximum 10
     */
    public numberOfTopProductsPerQuestionnairePage?: number;

}
